import axios from '@/utils/axios';

export function GetActivityOverallDetail() {
    return axios({
        url: '/activity/overall/detail',
        method: 'get'
    });
}

export function GetActivityPersonalDetail() {
    return axios({
        url: '/activity/personal/detail',
        method: 'get'
    });
}

export function ActivityPermissionVerification() {
    return axios({
        url: '/activity/permission/verification',
        method: 'get'
    });
}

export function AddActivityAddress(consignee, city, area, address, mobile) {
    return axios({
        url: '/activity/address/add',
        method: 'post',
        params: {consignee, city, area, address, mobile},
    });
}

export function CheckActivityDate() {
    return axios({
        url: '/activity/date/check',
        method: 'get'
    });
}

export function CheckActivityOrderSubmit() {
    return axios({
        url: '/activity/order-submit/check',
        method: 'get'
    });
}